/**
 * Copyright (c) Qwoach LLC 2026. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import DbBaseObject from "@shared/DbBaseObject";
import {Type, classToClass} from "@qwoach/class-transformer-wrapper";
import SessionPlanItem from "@shared/Journal/SessionPlanItem";
import {JournalEntryType} from "@shared/Journal/JournalEntryType";
import {createDefaultSessionPlanItems} from "@shared/Journal/SessionPlanDefaultItems";

export default class SessionPlanTemplateItem extends DbBaseObject {
	entryType: string = JournalEntryType.TLSW_SESSION_PLAN

	@Type(() => SessionPlanItem)
	items: SessionPlanItem[] = []

	constructor(options = {}) {
		super(options)
		this.applyOptions(options)
	}

	getCurrentSchemaVersion() {
		return 1
	}

	regenerateId() {
		this.id = this.entryType || JournalEntryType.TLSW_SESSION_PLAN
		return this
	}

	setEntryType(entryType) {
		this.entryType = entryType || JournalEntryType.TLSW_SESSION_PLAN
		this.regenerateId()
		return this
	}

	setItems(items = []) {
		this.items = this.createLayoutItems(items)
		this.recalculateItemSortIndexes()
		this.updatedAt = Date.now()
		return this
	}

	createLayoutItems(items = []) {
		return (items || []).map(item => this.createLayoutItem(item))
	}

	createLayoutItem(item) {
		let layoutItem = classToClass(item)
		layoutItem.content = null
		layoutItem.tags = []
		layoutItem.isReadonly = false
		return layoutItem
	}

	recalculateItemSortIndexes() {
		this.items = this.items || []
		this.items.forEach((item, index) => {
			item.sortIndex = index
		})
	}

	getItemArray() {
		return [...(this.items || [])].sort((left, right) => (left.sortIndex || 0) - (right.sortIndex || 0))
	}

	getItemsClone() {
		return classToClass(this.getItemArray())
	}

	applyToSessionPlanEntry(sessionPlanEntry) {
		sessionPlanEntry.applyLayoutItems(this.getItemsClone())
		return sessionPlanEntry
	}

	static createDefault(entryType = JournalEntryType.TLSW_SESSION_PLAN, options = {}) {
		let templateItem = new SessionPlanTemplateItem({entryType})
		templateItem.setEntryType(entryType)
		templateItem.setItems(createDefaultSessionPlanItems(entryType, options))
		return templateItem
	}

	static createFromSessionPlanEntry(sessionPlanEntry) {
		let templateItem = new SessionPlanTemplateItem({entryType: sessionPlanEntry.type})
		templateItem.setEntryType(sessionPlanEntry.type)
		templateItem.setItems(sessionPlanEntry.getLayoutItemArray())
		return templateItem
	}
}
